import { concat, defer, of } from "rxjs";
export function startWithDeferred(factory, scheduler) {
    return (source) => concat(defer(() => {
        const value = factory();
        return scheduler ? of(value, scheduler) : of(value);
    }), source);
}
//# sourceMappingURL=startWithDeferred.js.map